// extracted by mini-css-extract-plugin
export var acitonButtons = "_m2-0";
export var additionalIcon = "_m2-f";
export var block = "_m2-1";
export var blockContent = "_m2-7";
export var blockDescription = "_m2-8";
export var blockIcon = "_m2-9";
export var blockTitle = "_m2-6";
export var border = "_m2-a";
export var center = "_m2-l";
export var edge = "_m2-b";
export var edgeLabel = "_m2-c";
export var edgePath = "_m2-d";
export var error = "_m2-e";
export var flowchart = "_m2-g";
export var flowchartContent = "_m2-h";
export var highlighted = "_m2-3";
export var hover = "_m2-4";
export var icon = "_m2-i";
export var left = "_m2-m";
export var navButton = "_m2-j";
export var navButtons = "_m2-k";
export var right = "_m2-n";
export var selected = "_m2-2";
export var small = "_m2-5";